/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports4ColumnBannersViewProps } from './hosports-4-column-banners';

export default (props: IHosports4ColumnBannersViewProps) => {
    return (
        <h2>{'hosports-four-column-banners-view'}</h2>
    );
};
